import styles from "./SVGGradientsEditor.module.css";
import { gsap } from "gsap";
import { Draggable } from "gsap/Draggable";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { useRef ,useState,useEffect} from "react";

gsap.registerPlugin(MotionPathPlugin, Draggable);

const SVGGradientsEditor = (
  { _x1 = 0, _y1 = 0, _x2 = 32, _y2 = 32, onChange = () => {} ,  _offsets = [0, 1]}
) => {
  const gradientsControlSvg = useRef(null);
  const gradientsControlBox = useRef(null);
  const gradientsControlLine = useRef(null);
  const gradientsControl0 = useRef(null);
  const gradientsControl1 = useRef(null);
  const [x1, setX1] = useState(_x1);
  const [y1, setY1] = useState(_y1);
  const [x2, setX2] = useState(_x2);
  const [y2, setY2] = useState(_y2);
  const [offsets, setOffsets] = useState(_offsets);

  useEffect(() => {
    Draggable.create(gradientsControl0.current, {
      onDrag: function () {
        controlMove(this, 0);
      },
    });

    Draggable.create(gradientsControl1.current, {
      onDrag: function () {
        controlMove(this, 1);
      },
    });
  }, []);
  
  useEffect(() => {
    document
      .querySelectorAll(`.${styles.gradientsColor}`)
      .forEach((item, index) => {
        let target = item;
        let path = gradientsControlLine.current;
        let bounds = path.getBBox();
        let clamp = gsap.utils.clamp(0, 1);
        let prevProgress = offsets[index];
        let tl = gsap.timeline({
          paused: true,
        })

        tl.to(target, {
          motionPath: {
            path: path,
            align: path,
            autoRotate: true,
            alignOrigin: [0.5, 0.5],
          },
          immediateRender: true,
          ease: "none",
        });

        tl.progress(prevProgress);

        Draggable.create(target, {
          type: "x",
          onDrag: function () {
            var progress = clamp((this.x - bounds.x) / bounds.width);
            
            if (progress !== prevProgress) {
              tl.progress(progress);
              prevProgress = progress;
              let newArray = offsets;
              newArray[index] = progress;
              setOffsets(newArray);
              onChange({
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                offsets:newArray
              });
            } else {
              return false;
            }
          },
        });
      });
  }, [x1,y1,x2,y2]);

  const controlMove = (e, controlIndex) => {
    setControlPosition(
      getControlPosition(e.pointerX, e.pointerY, e.target).x,
      getControlPosition(e.pointerX, e.pointerY, e.target).y,
      e.target,
      controlIndex
    );
  };

  const setControlPosition = (x, y, target, controlIndex) => {
    if (controlIndex === 0) {
      setX1(x);
      setY1(y);
      onChange({
        x1: x,
        y1: y,
        x2: x2,
        y2: y2,
        offsets:offsets
      });
    } else if (controlIndex === 1) {
      setX2(x);
      setY2(y);
      onChange({
        x1: x2,
        y1: y1,
        x2: x,
        y2: y,
        offsets:offsets
      });
    }
  };

  const getControlPosition = (cx, cy, target) => {
    let targetClientRect = target.getBoundingClientRect();
    let gradientsControlSvgClientRect =
      gradientsControlSvg.current.getBoundingClientRect();
    return {
      x:
        ((targetClientRect.left +
          targetClientRect.width / 2 -
          gradientsControlSvgClientRect.left) /
          gradientsControlSvgClientRect.width) *
        32,
      y:
        ((targetClientRect.top +
          targetClientRect.height / 2 -
          gradientsControlSvgClientRect.top) /
          gradientsControlSvgClientRect.width) *
        32,
    };
  };


  return (
    
    <div className={styles.gradientsControlBox} ref={gradientsControlBox}>
      <div
        className={`${styles.gradientsControl1} ${styles.gradientsControl}`}
        ref={gradientsControl0}
      ></div>
      {offsets.map((item) => {
        return <div className={styles.gradientsColor}></div>;
      })}
      <div
        className={`${styles.gradientsControl2} ${styles.gradientsControl}`}
        ref={gradientsControl1}
      ></div>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.gradientsControlSvg}
        ref={gradientsControlSvg}
      >
        <path ref={gradientsControlLine} d={`M ${x1},${y1} L ${x2},${y2}`} />
      </svg>
    </div>
  );
};
export default SVGGradientsEditor;
